import React, { useState } from "react";
import { ExternalLink, GraduationCap, BookOpen, AlertTriangle, Monitor, RefreshCw } from "lucide-react";
import Navbar from "../components/Navbar"
import Footer from "../components/Footer"
// Mock components since they're not available in this environment

const ResultPage = () => {
  const [activePortal, setActivePortal] = useState("primary");
  const [showIframe, setShowIframe] = useState(false);
  const [iframeError, setIframeError] = useState(false);

  const handleOpenPortal = (portalType) => {
    setActivePortal(portalType);
    setShowIframe(true);
    setIframeError(false);
  };

  const handleDirectOpen = (url) => {
    window.open(url, "_blank", "width=1200,height=800,scrollbars=yes,resizable=yes");
  };

  const handleIframeError = () => {
    setIframeError(true);
  };

  return (
    <div className="flex flex-col min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100">
      <Navbar />
      
      <div className="container flex-1 px-4 py-8 mx-auto">
        <div className="max-w-6xl mx-auto">
          {/* Header Section */}
          <div className="mb-12 text-center">
            {/* <div className="inline-flex items-center justify-center w-16 h-16 mb-4 bg-blue-600 rounded-full">
              <Monitor className="w-8 h-8 text-white" />
            </div> */}
            <h1 className="mb-4 text-4xl font-bold text-gray-800">Check Your Result</h1>
            <p className="max-w-2xl mx-auto text-lg text-gray-600">
              Access your academic results through our integrated portal system
            </p>
          </div>

          {!showIframe ? (
            // Portal Selection Cards
            <div className="grid gap-8 mb-8 md:grid-cols-2">
              {/* Primary Results Card */}
              <div className="overflow-hidden transition-all duration-300 bg-white shadow-xl rounded-2xl hover:shadow-2xl">
                <div className="p-6 text-white bg-gradient-to-r from-green-500 to-emerald-600">
                  <div className="flex items-center">
                    <GraduationCap className="w-8 h-8 mr-3" />
                    <div>
                      <h3 className="text-2xl font-bold">Primary Results</h3>
                      <p className="text-green-100">Primary 1 - Primary 6</p>
                    </div>
                  </div>
                </div>
                
                <div className="p-6">
                  <div className="mb-6">
                    <h4 className="mb-2 font-semibold text-gray-800">What you'll need:</h4>
                    <ul className="space-y-1 text-sm text-gray-600">
                      <li>• Portal Number</li>
                      <li>• Academic Session</li>
                      <li>• Class Level</li>
                      <li>• Class Section (if applicable)</li>
                    </ul>
                  </div>
                  
                  <div className="space-y-3">
                    
                    <button
                      onClick={() => handleDirectOpen("https://schoolifix.com/check")}
                      className="flex items-center justify-center w-full px-6 py-4 font-semibold text-green-600 transition-all duration-200 border-2 border-green-600 rounded-lg hover:bg-green-50"
                    >
                      <ExternalLink className="w-5 h-5 mr-2" />
                     Check result
                    </button>
                  </div>
                </div>
              </div>

              {/* Secondary Results Card */}
              <div className="overflow-hidden transition-all duration-300 bg-white shadow-xl rounded-2xl hover:shadow-2xl">
                <div className="p-6 text-white bg-gradient-to-r from-blue-500 to-indigo-600">
                  <div className="flex items-center">
                    <BookOpen className="w-8 h-8 mr-3" />
                    <div>
                      <h3 className="text-2xl font-bold">Secondary Results</h3>
                      <p className="text-blue-100">JSS 1 - SS 3</p>
                    </div>
                  </div>
                </div>
                
                <div className="p-6">
                  <div className="mb-6">
                    <h4 className="mb-2 font-semibold text-gray-800">What you'll need:</h4>
                    <ul className="space-y-1 text-sm text-gray-600">
                      <li>• Portal Number</li>
                      <li>• Academic Session</li>
                      <li>• Class Level</li>
                      <li>• Class Section (if applicable)</li>
                    </ul>
                  </div>
                  
                  <div className="space-y-3">
                    
                    <button
                      onClick={() => handleDirectOpen("https://schoolifix.com/secondary")}
                      className="flex items-center justify-center w-full px-6 py-4 font-semibold text-blue-600 transition-all duration-200 border-2 border-blue-600 rounded-lg hover:bg-blue-50"
                    >
                      <ExternalLink className="w-5 h-5 mr-2" />
                     Check result
                    </button>
                  </div>
                </div>
              </div>
            </div>
          ) : (
            // Portal View
            <div className="overflow-hidden bg-white shadow-xl rounded-2xl">
              {/* Portal Header */}
              <div className={`${activePortal === "primary" ? "bg-green-600" : "bg-blue-600"} text-white p-4`}>
                <div className="flex items-center justify-between">
                  <div className="flex items-center">
                    {activePortal === "primary" ? (
                      <GraduationCap className="w-6 h-6 mr-3" />
                    ) : (
                      <BookOpen className="w-6 h-6 mr-3" />
                    )}
                    <div>
                      <h3 className="text-lg font-bold">
                        {activePortal === "primary" ? "Primary Results Portal" : "Secondary Results Portal"}
                      </h3>
                      <p className="text-sm opacity-90">
                        {activePortal === "primary" ? "schoolifix.com/check" : "schoolifix.com/secondary"}
                      </p>
                    </div>
                  </div>
                  
                  <div className="flex items-center space-x-2">
                    <button
                      onClick={() => handleDirectOpen(activePortal === "primary" ? "https://schoolifix.com/check" : "https://schoolifix.com/secondary")}
                      className="p-2 transition-all duration-200 rounded-lg hover:bg-white hover:bg-opacity-20"
                      title="Open in new window"
                    >
                      <ExternalLink className="w-5 h-5" />
                    </button>
                    
                    <button
                      onClick={() => setShowIframe(false)}
                      className="p-2 transition-all duration-200 rounded-lg hover:bg-white hover:bg-opacity-20"
                      title="Back to selection"
                    >
                      ×
                    </button>
                  </div>
                </div>
              </div>

              {/* Iframe Container */}
              <div className="relative">
                {iframeError ? (
                  // Error State
                  <div className="flex items-center justify-center h-96 bg-gray-50">
                    <div className="p-8 text-center">
                      <AlertTriangle className="w-16 h-16 mx-auto mb-4 text-amber-500" />
                      <h3 className="mb-2 text-xl font-bold text-gray-800">Content Blocked</h3>
                      <p className="max-w-md mb-6 text-gray-600">
                        This website cannot be displayed in an embedded view due to security restrictions. 
                        Please use the "Open in New Window" option instead.
                      </p>
                      
                      <div className="space-y-3">
                        <button
                          onClick={() => handleDirectOpen(activePortal === "primary" ? "https://schoolifix.com/check" : "https://schoolifix.com/secondary")}
                          className={`px-6 py-3 ${activePortal === "primary" ? "bg-green-600 hover:bg-green-700" : "bg-blue-600 hover:bg-blue-700"} text-white rounded-lg font-semibold transition-all duration-200 flex items-center mx-auto`}
                        >
                          <ExternalLink className="w-5 h-5 mr-2" />
                         Check result
                        </button>
                        
                        <button
                          onClick={() => {
                            setIframeError(false);
                            setShowIframe(false);
                          }}
                          className="block mx-auto text-gray-600 transition-all duration-200 hover:text-gray-800"
                        >
                          Back to Portal Selection
                        </button>
                      </div>
                    </div>
                  </div>
                ) : (
                  // Iframe
                  <iframe
                    src={activePortal === "primary" ? "https://schoolifix.com/check" : "https://schoolifix.com/secondary"}
                    className="w-full h-96 md:h-[600px] border-0"
                    title={`${activePortal} Results Portal`}
                    onError={handleIframeError}
                    sandbox="allow-same-origin allow-scripts allow-forms allow-popups allow-top-navigation"
                  />
                )}
              </div>
            </div>
          )}

          {/* Help Section */}
          <div className="p-6 mt-12 bg-white shadow-lg rounded-xl">
            <h3 className="flex items-center mb-4 text-xl font-bold text-gray-800">
              <AlertTriangle className="w-6 h-6 mr-2 text-amber-500" />
              Troubleshooting
            </h3>
            
            <div className="grid gap-6 text-sm text-gray-700 md:grid-cols-2">
              <div>
                <h4 className="mb-2 font-semibold">If the portal view doesn't work:</h4>
                <ul className="space-y-1">
                  <li>• Click "Open in New Window" instead</li>
                  <li>• Disable ad blockers temporarily</li>
                  <li>• Try a different browser</li>
                  <li>• Clear your browser cache</li>
                </ul>
              </div>
              
              <div>
                <h4 className="mb-2 font-semibold">For best experience:</h4>
                <ul className="space-y-1">
                  <li>• Use Chrome, Firefox, or Safari</li>
                  <li>• Ensure stable internet connection</li>
                  <li>• Have your portal details ready</li>
                  <li>• Allow popups for this site</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default ResultPage;